import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllUnidadeMedidaCadastro } from '../service';
import {
  LIST_UNIDADE_MEDIDA_CADASTRO,
  LIST_UNIDADE_MEDIDA_CADASTRO_PENDING,
  LIST_UNIDADE_MEDIDA_CADASTRO_SUCCESS,
  LIST_UNIDADE_MEDIDA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllUnidadeMedidaCadastro(action) {
  yield put({ type: LIST_UNIDADE_MEDIDA_CADASTRO_PENDING })

  try {
    const list = yield call(findAllUnidadeMedidaCadastro)
    
    yield put({ type: LIST_UNIDADE_MEDIDA_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_UNIDADE_MEDIDA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllUnidadeMedidaCadastro() {
  yield takeLatest(LIST_UNIDADE_MEDIDA_CADASTRO, sagaListAllUnidadeMedidaCadastro)
}